/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BusinessComponentType {
    Product = 0,
    Process = 1,
    Other = 2,
}
